import { render } from "./CometChatBadgeCount.vue?vue&type=template&id=59b6d0a4"
import script from "./CometChatBadgeCount.vue?vue&type=script&lang=js"
export * from "./CometChatBadgeCount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__